import { Grid, Box, Typography, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { Bucket } from "../../../../api/config/apiConfig";
import moment from "moment";

const PackingInventoryDownload = ({ formContent }) => {
  const formatDate = (date) => {
    return date ? moment(date).format("DD-MMM-YYYY") : "-";
  };

  return (
    <>
      <div className="premium-print-container mx-4" style={{ pageBreakInside: 'avoid' }}>
        <Box sx={{ borderBottom: '2px solid var(--text-main)', mb: 3, pb: 1 }}>
          <Typography variant="h5" sx={{ fontWeight: 800, color: 'var(--text-main)', textTransform: 'uppercase', letterSpacing: '1px' }}>
            Packing Inventory
          </Typography>
        </Box>

        {/* file detail*/}
        <Box sx={{ mb: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', gap: 1, mb: 0.5 }}>
                <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '11px' }}>Client Name:</Typography>
                <Typography variant="body2" sx={{ fontSize: '11px' }}>{formContent?.clientName || "-"}</Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: 1, mb: 0.5 }}>
                <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '11px' }}>Organization:</Typography>
                <Typography variant="body2" sx={{ fontSize: '11px' }}>{formContent?.organization || "-"}</Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: 1, mb: 0.5 }}>
                <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '11px' }}>Origin Address:</Typography>
                <Typography variant="body2" sx={{ fontSize: '11px' }}>{formContent?.originAddress || "-"}</Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '11px' }}>Destination Address:</Typography>
                <Typography variant="body2" sx={{ fontSize: '11px' }}>{formContent?.destinationAddress || "-"}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', gap: 1, mb: 0.5 }}>
                <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '11px' }}>File Ref:</Typography>
                <Typography variant="body2" sx={{ fontSize: '11px' }}>{formContent?.fileRef || "-"}</Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: 1, mb: 0.5 }}>
                <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '11px' }}>Van No.:</Typography>
                <Typography variant="body2" sx={{ fontSize: '11px' }}>{formContent?.vanNo || "-"}</Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '11px' }}>Date:</Typography>
                <Typography variant="body2" sx={{ fontSize: '11px' }}>{formatDate(formContent?.date)}</Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
        {/* /file detail */}

        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6}>
             <Typography variant="caption" sx={{ fontWeight: 700, mb: 1, display: 'block' }}>DESCRIPTIVE SYMBOLS</Typography>
             <Box sx={{ p: 1, bgcolor: '#f8f9fa', borderRadius: '4px' }}>
                <Grid container spacing={1}>
                  {[
                    { key: 'professionalBooks', label: 'PB - PROFESSIONAL BOOKS' },
                    { key: 'colorTV', label: 'C/T - COLOR TV' },
                    { key: 'professionalEquipments', label: 'PE - PROFESSIONAL EQUIPMENTS' },
                    { key: 'carrierDis', label: 'CD - CARRIER DISASSEMBLED' },
                    { key: 'professionalPapers', label: 'PP - PROFESSIONAL PAPERS' },
                    { key: 'disByOwner', label: 'DBO - DISASSEMBLED BY OWNER' },
                    { key: 'carrierPacked', label: 'CP - CARRIER PACKED' }
                  ].map(item => (
                    <Grid item xs={6} key={item.key}>
                      <Box sx={{ 
                        fontSize: '8px', 
                        p: '4px', 
                        textAlign: 'center',
                        border: '1px solid #ddd',
                        borderRadius: '2px',
                        bgcolor: formContent?.descriptiveSymbols?.[item.key] ? '#00aff0' : '#fff',
                        color: formContent?.descriptiveSymbols?.[item.key] ? '#fff' : '#666',
                        fontWeight: formContent?.descriptiveSymbols?.[item.key] ? 700 : 400
                      }}>
                        {item.label}
                      </Box>
                    </Grid>
                  ))}
                </Grid>
             </Box>
          </Grid>
          <Grid item xs={6}>
             <Typography variant="caption" sx={{ fontWeight: 700, mb: 1, display: 'block' }}>EXCEPTION SYMBOLS</Typography>
             <Box sx={{ p: 1, bgcolor: '#f8f9fa', borderRadius: '4px' }}>
                <Grid container spacing={1}>
                  {[
                    { key: 'rent', label: 'RE - RENT' },
                    { key: 'dented', label: 'D - DENTED' },
                    { key: 'rubbed', label: 'R - RUBBED' },
                    { key: 'broken', label: 'BR - BROKEN' },
                    { key: 'faded', label: 'F - FADED' },
                    { key: 'rusted', label: 'RU - RUSTED' },
                    { key: 'burned', label: 'BU - BURNED' },
                    { key: 'loose', label: 'L - LOOSE' },
                    { key: 'badly', label: 'W - BADLY' },
                    { key: 'chipped', label: 'CH - CHIPPED' },
                    { key: 'marred', label: 'M - MARRED' }
                  ].map(item => (
                    <Grid item xs={4} key={item.key}>
                      <Box sx={{ 
                        fontSize: '8px', 
                        p: '4px', 
                        textAlign: 'center',
                        border: '1px solid #ddd',
                        borderRadius: '2px',
                        bgcolor: formContent?.exceptions?.[item.key] ? '#00aff0' : '#fff',
                        color: formContent?.exceptions?.[item.key] ? '#fff' : '#666',
                        fontWeight: formContent?.exceptions?.[item.key] ? 700 : 400
                      }}>
                        {item.label}
                      </Box>
                    </Grid>
                  ))}
                </Grid>
             </Box>
          </Grid>
        </Grid>

        <div className="table-wrapper">
          <Table size="small" sx={{ border: "1px solid #dee2e6" }}>
            <TableHead>
              <TableRow sx={{ bgcolor: "#f8f9fa" }}>
                <TableCell sx={{ fontWeight: 700, fontSize: "10px", width: "10%", border: "1px solid #dee2e6" }}>Item No.</TableCell>
                <TableCell sx={{ fontWeight: 700, fontSize: "10px", width: "50%", border: "1px solid #dee2e6" }}>Goods Description</TableCell>
                <TableCell sx={{ fontWeight: 700, fontSize: "10px", width: "20%", border: "1px solid #dee2e6" }}>Condition at Origin</TableCell>
                <TableCell sx={{ fontWeight: 700, fontSize: "10px", width: "20%", border: "1px solid #dee2e6" }}>Condition at Destination</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {formContent?.dataRows?.length > 0 ? (
                formContent.dataRows.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell sx={{ fontSize: "9px", border: "1px solid #dee2e6" }}>{index + 1}</TableCell>
                    <TableCell sx={{ fontSize: "9px", border: "1px solid #dee2e6" }}>{row.description || "-"}</TableCell>
                    <TableCell sx={{ fontSize: "9px", border: "1px solid #dee2e6" }}>{row.conditionAtOrigin || "-"}</TableCell>
                    <TableCell sx={{ fontSize: "9px", border: "1px solid #dee2e6" }}>{row.conditionAtDestination || "-"}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ fontSize: "9px", border: "1px solid #dee2e6" }}>No Records to Show</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>

        {/* Remarks */}
        {formContent?.remarks?.trim()?.length > 0 && (
          <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '11px', whiteSpace: 'nowrap' }}>Remarks:</Typography>
            <Typography variant="body2" sx={{ fontSize: '11px' }}>{formContent.remarks}</Typography>
          </Box>
        )}

        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" sx={{ fontSize: '11px', lineHeight: 1.5 }}>
            WE HAVE CHECKED ALL THE ITEM LISTED AND NUMBERED{" "}
            <strong>{formContent?.number1 || "-"}</strong> to{" "}
            <strong>{formContent?.number2 || "-"}</strong> INCLUSIVE
            AND ACKNOWLEDGE THAT THIS IS A TRUE AND COMPLETE LIST OF THE GOODS.
          </Typography>
        </Box>

        <Grid container spacing={2} sx={{ mt: 3 }}>
          <Grid item xs={6} sx={{ textAlign: 'center' }}>
            <Box sx={{ height: "80px", display: 'flex', justifyContent: 'center', alignItems: 'flex-end', borderBottom: '1px solid #000', mb: 1, width: '180px', mx: 'auto' }}>
              {formContent?.destContractorSign?.trim()?.length > 0 && (
                <img src={`${Bucket}${formContent.destContractorSign}`} height={70} style={{ objectFit: 'contain' }} alt="Agent at Destination" />
              )}
            </Box>
            <Typography variant="caption" sx={{ fontWeight: 700, fontSize: '10px' }}>
              Contractor Carrier / Agent at DESTINATION
            </Typography>
          </Grid>
          <Grid item xs={6} sx={{ textAlign: 'center' }}>
            <Box sx={{ height: "80px", display: 'flex', justifyContent: 'center', alignItems: 'flex-end', borderBottom: '1px solid #000', mb: 1, width: '180px', mx: 'auto' }}>
              {formContent?.originContractorSign?.trim()?.length > 0 && (
                <img src={`${Bucket}${formContent.originContractorSign}`} height={70} style={{ objectFit: 'contain' }} alt="Agent at Origin" />
              )}
            </Box>
            <Typography variant="caption" sx={{ fontWeight: 700, fontSize: '10px' }}>
              Contractor Carrier / Agent at ORIGIN
            </Typography>
          </Grid>

          <Grid item xs={6} sx={{ textAlign: 'center', mt: 2 }}>
            <Box sx={{ height: "80px", display: 'flex', justifyContent: 'center', alignItems: 'flex-end', borderBottom: '1px solid #000', mb: 1, width: '180px', mx: 'auto' }}>
              {formContent?.clientSignDestination?.trim()?.length > 0 && (
                <img src={`${Bucket}${formContent.clientSignDestination}`} height={70} style={{ objectFit: 'contain' }} alt="Client at Destination" />
              )}
            </Box>
            <Typography variant="caption" sx={{ fontWeight: 700, fontSize: '10px' }}>
              Client / Authorized Person at DESTINATION
            </Typography>
          </Grid>
          <Grid item xs={6} sx={{ textAlign: 'center', mt: 2 }}>
            <Box sx={{ height: "80px", display: 'flex', justifyContent: 'center', alignItems: 'flex-end', borderBottom: '1px solid #000', mb: 1, width: '180px', mx: 'auto' }}>
              {formContent?.clientSign?.trim()?.length > 0 && (
                <img src={`${Bucket}${formContent.clientSign}`} height={70} style={{ objectFit: 'contain' }} alt="Client at Origin" />
              )}
            </Box>
            <Typography variant="caption" sx={{ fontWeight: 700, fontSize: '10px' }}>
               Client / Authorized Person at ORIGIN
            </Typography>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default PackingInventoryDownload;

